import styled from 'styled-components';
import { Container as ContainerComponent } from '../../../theme/layout';
import { colors, fontWeights, fonts } from '../../../theme/styled';
import { LinkList } from '../../../components/linkList/linkList.component';
import { text } from '../../../theme/typography';
import { media } from '../../../theme/media';

export const BottomBar = styled.section`
  background-color: ${colors.black};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 24px;
  padding-right: 24px;

  ${media.tabletLarge`
    padding-left: 0;
    padding-right: 0;
  `};
`;

export const Container = styled(ContainerComponent)`
  justify-content: flex-start;
  margin: 0;
  max-width: 100%;
  padding-bottom: 16px;

  ${media.tabletLarge`
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    padding-top: 0;
    padding-bottom: 0;
  `};
`;

export const Copyright = styled.p`
  ${text};
  font-family: ${fonts.smallFont};
  font-weight: ${fontWeights.normal};
  color: ${colors.white};
  font-size: 12px;
  opacity: 0.68;
  line-height: 1.67;
  margin: 0;
  padding: 16px 0;

  ${media.tabletLarge`
    padding: 0;
  `}
`;

export const PhotoDisclaimer = styled(Copyright)``;

export const Links = styled(LinkList)`
  width: auto;
  padding: 12px 0;
  text-align: center;

  ${media.tabletLarge`
    padding: 0;
  `}

  a {
    ${text};
    font-family: ${fonts.smallFont};
    font-weight: ${fontWeights.normal};
    color: ${colors.white};
    font-size: 12px;
    line-height: 1;
    cursor: pointer;

    ${media.tabletLarge`
      line-height: 1.67;
    `}

    &:hover {
      text-decoration: underline;
    }
  }

  li {
    margin-left: 16px;

    &:first-child {
      margin-left: 0;
    }
  }

  ${media.tabletLarge`
    padding-top: 0;
  `}
`;

export const SocialSection = styled.section`
  order: 0;

  ${media.tabletLarge`
    order: 2;
    padding: 16px 20px;
  `}
`;

export const LegalTextSection = styled.section`
  order: 2;
  text-align: center;

  ${media.tabletLarge`
    order: 1;
    padding: 16px 20px;
    text-align: left;
  `}
`;

export const LinksSection = styled.section`
  order: 1;

  ${media.tabletLarge`
    order: 0;
    width: 100%;
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding: 16px 0;
  `}
`;
